import {UserTracker} from "../index.js";

const event = [
    "main:alarm-tab-mention:click",
    "main:alarm-tab-registrant:click",
    "main:alarm-tab-worker:click",
]

export const AlarmTabTracker = () => {
    const Tracker = Object.create(UserTracker)
    Tracker.track = (json) => {
        if (event.indexOf(json.event) < 0) return;
        return Tracker.trackAction(json)
    }

    return Tracker;
}